import React from 'react';
import {
    EmojiAngry,
    EmojiFrown,
    EmojiNeutral,
    EmojiSmile,
    EmojiLaughing,
    Star,
    StarFill,
    XCircleFill,
    Icon1CircleFill,
    Icon2CircleFill,
    Icon3CircleFill,
    Icon4CircleFill,
    Icon5CircleFill,
    Icon6CircleFill,
    Icon7CircleFill,
    Icon8CircleFill,
    Icon9CircleFill,
    Icon0CircleFill
} from 'react-bootstrap-icons';
import {
    back,
    next,
    menu,
    down
} from 'Images'
import IconTypeEnum from "Enum/IconTypeEnum.js";

export const iconTextDictionary = {
    [IconTypeEnum.FACE_VERY_UNHAPPY]: 'Very Bad',
    [IconTypeEnum.FACE_UNHAPPY]: 'Bad',
    [IconTypeEnum.FACE_NEUTRAL]: 'Neutral',
    [IconTypeEnum.FACE_HAPPY]: 'Good',
    [IconTypeEnum.FACE_VERY_HAPPY]: 'Very Good'
};

export const Icon = ({ type, selected=false, ...rest }) => {
    switch (type) {
        case IconTypeEnum.STAR:
            return selected ? <StarFill {...rest} /> : <Star {...rest} />;
        case IconTypeEnum.FACE_VERY_UNHAPPY:
            return <EmojiAngry {...rest} />;
        case IconTypeEnum.FACE_UNHAPPY:
            return <EmojiFrown {...rest} />;
        case IconTypeEnum.FACE_NEUTRAL:
            return <EmojiNeutral {...rest} />;
        case IconTypeEnum.FACE_HAPPY:
            return <EmojiSmile {...rest} />;
        case IconTypeEnum.FACE_VERY_HAPPY:
            return <EmojiLaughing {...rest} />;
        case IconTypeEnum.EXIT:
            return <XCircleFill {...rest} />;
        case IconTypeEnum.NUM + '1':
            return <Icon1CircleFill {...rest} />;
        case IconTypeEnum.NUM + '2':
            return <Icon2CircleFill {...rest} />;
        case IconTypeEnum.NUM + '3':
            return <Icon3CircleFill {...rest} />;
        case IconTypeEnum.NUM + '4':
            return <Icon4CircleFill {...rest} />;
        case IconTypeEnum.NUM + '5':
            return <Icon5CircleFill {...rest} />;
        case IconTypeEnum.NUM + '6':
            return <Icon6CircleFill {...rest} />;
        case IconTypeEnum.NUM + '7':
            return <Icon7CircleFill {...rest} />;
        case IconTypeEnum.NUM + '8':
            return <Icon8CircleFill {...rest} />;
        case IconTypeEnum.NUM + '9':
            return <Icon9CircleFill {...rest} />;
        case IconTypeEnum.NUM + '10':
            return <Icon0CircleFill {...rest} />;
        case IconTypeEnum.MENU:
            return <img src={menu} alt={'Menu'} {...rest} />;
        case IconTypeEnum.BACK:
            return <img src={back} alt={'Back'} {...rest} />;
        case IconTypeEnum.NEXT:
            return <img src={next} alt={'Next'} {...rest} />;
        case IconTypeEnum.DOWN:
            return <img src={down} alt={'Next'} {...rest} />;
        default:
            return <div className={`w-full text-center text-base`} {...rest}>{type}</div>
    }
};
